<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 32 32"
>
  <circle
    [attr.stroke]="color"
    cx="16"
    cy="16"
    r="15"
    stroke-width="2"
  />
  <path
    [attr.fill]="color"
    d="M14.2532 9.03467C14.1212 7.95867 14.9572 7 16.0506 7C17.0786 7 17.8866 7.90133 17.7572 8.93467L16.7479 17.0053C16.7012 17.3827 16.3799 17.6667 15.9999 17.6667C15.6199 17.6667 15.2986 17.3827 15.2506 17.0053L14.2532 9.03467ZM15.9999 23.3333C15.0799 23.3333 14.3332 22.5867 14.3332 21.6667C14.3332 20.7467 15.0799 20 15.9999 20C16.9199 20 17.6666 20.7467 17.6666 21.6667C17.6666 22.5867 16.9199 23.3333 15.9999 23.3333Z"
  />
</svg>
